import React, { useState, useEffect, useContext, Fragment } from 'react';
import useCourseStyles from './styles';
import { getCourseList } from './api';
import CourseCard from './courseCard';
import Carousel from '../../components/carousel';
import PageContext from '../../contexts/pageContext';

export default function courses({ sectionData }) {
  const {
    isMobile,
    layout: { containerWidth },
    baseURLs,
    hashToken,
    isMasterTemplate,
    isEdit,
    countryCode,
    currencySymbol
  } = useContext(PageContext);
  const [cardList, setCardList] = useState(null);
  const [errored, setErrored] = useState(false);
  const [fallBackImages, setFallbackImages] = useState([]);
  const [showShimmer, setShowShimmer] = useState(true);
  const classes = useCourseStyles({ containerWidth, isMobile });
  const [nodeData] = sectionData?.components;
  const [utmParams, setUtmParams] = useState('');

  const handleApiCall = () => {
    if (baseURLs) {
      getCourseList(baseURLs, hashToken)
        .then((response) => {
          const placeholders = nodeData?.cardCarousel?.metadata?.placeholders;
          const coursesData = response?.data?.coursesData;

          if (coursesData && coursesData.length) {
            setCardList(response?.data?.coursesData);
            setShowShimmer(false);
          } else {
            // For Edit Page: If no data found, show placeholders. If placeholder doesn't come from backend, show shimmer.
            if (isEdit) {
              if (placeholders && placeholders.length) {
                setShowShimmer(false);
                setFallbackImages(placeholders);
              }
            }
            // For User Website & Draft Preview: If no data found, hide section.
            else setErrored(true);
          }
        })
        .catch((err) => {
          const errMsg = err?.response?.data?.data?.message;
          if (errMsg === 'NOT_FOUND') {
            if (
              nodeData?.cardCarousel?.metadata?.placeholders?.length &&
              isEdit
            ) {
              setShowShimmer(false);
              setFallbackImages(nodeData?.cardCarousel?.metadata?.placeholders);
            } else if (!isEdit) {
              setErrored(true);
            }
          }
        });
    }
  };

  useEffect(() => {
    const placeholders = nodeData?.cardCarousel?.metadata?.placeholders;
    // For Master template Preview: Show placeholder images. If placeholder doesn't come from backend, show shimmer.
    if (isMasterTemplate) {
      if (placeholders && placeholders.length) {
        setShowShimmer(false);
        setFallbackImages(placeholders);
      }
    }
    // other
    else {
      handleApiCall();
    }
    const params = new URLSearchParams(window.location.search);
    const utmParams = params.get('flyy_utm_referrer');
    if (utmParams) {
      setUtmParams(utmParams);
    }
  }, []);

  const settings = {
    className: classes.slickContainer,
    infinite: false,
    slidesToShow: isMobile ? 1 : 3.5
  };

  const Wrapper =
    (cardList?.length || fallBackImages?.length) > settings.slidesToShow
      ? Carousel
      : SimpleCardsContainer;
  const wrapperProps =
    (cardList?.length || fallBackImages?.length) > settings.slidesToShow
      ? {
          settings,
          hideArrow: isMobile
        }
      : { classes };

  return errored ? null : (
    <div className={classes.coursesContainer}>
      <div className={classes.sectionContainer}>
        <div className={classes.coursesCardAndText}>
          <div className={classes.coursesText}>
            <span
              ref={nodeData?.heading?.refSetter}
              dangerouslySetInnerHTML={{
                __html: nodeData?.heading?.metadata?.value
              }}
            />
          </div>
          <h2 className={classes.coursesHeader}>
            <span
              ref={nodeData?.title?.refSetter}
              dangerouslySetInnerHTML={{
                __html: nodeData?.title?.metadata?.value
              }}
            />
          </h2>
          {!showShimmer ? (
            <Wrapper {...wrapperProps}>
              {cardList != null
                ? cardList?.map((card, index) => (
                    <CourseCard
                      key={index}
                      card={card}
                      countryCode={countryCode}
                      currencySymbol={currencySymbol}
                      utmParams={utmParams}
                    />
                  ))
                : fallBackImages?.map((dt, ind) => {
                    return (
                      <Fragment key={ind}>
                        <div style={{ padding: '0 12px', width: '100%' }}>
                          <img src={dt?.url} style={{ width: '100%' }} />
                        </div>
                      </Fragment>
                    );
                  })}
            </Wrapper>
          ) : (
            <div className={classes.shimmerContainer}>
              {Array.from({ length: isMobile ? 1 : 3 }).map((val, i) => {
                return <div className={classes.shine} key={i} />;
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function SimpleCardsContainer({ children, classes }) {
  return <div className={classes.singleCardContainer}>{children}</div>;
}
